import React from 'react';
import { User } from '../types';
import { LogoutIcon } from './icons';

interface HeaderProps {
  user: User;
  onLogout: () => void;
  logoUrl?: string;
}

const Header: React.FC<HeaderProps> = ({ user, onLogout, logoUrl }) => {
  return (
    <header className="bg-slate-900 bg-opacity-80 backdrop-blur-md shadow-lg sticky top-0 z-30">
      <div className="container mx-auto px-6 py-3 flex justify-between items-center">
        {logoUrl ? (
          <img src={logoUrl} alt="APEX University Logo" className="h-10" />
        ) : (
          <div className="text-xl font-bold text-white">APEX University</div>
        )}
        <div className="flex items-center space-x-4">
          <span className="text-gray-300">Bienvenido, <span className="font-semibold text-white">{user.name}</span></span>
          <button
            onClick={onLogout}
            className="flex items-center space-x-2 text-gray-400 hover:text-red-500 transition-colors duration-300"
            title="Cerrar Sesión"
          >
            <LogoutIcon className="h-6 w-6" />
            <span className="hidden sm:inline">Salir</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;